import React, { useCallback, useMemo } from 'react'
import { useOnSelectionChange } from '@xyflow/react'
import { useEntityGraphContext } from '../Wrapper/EntityGraphProvider'
import { PersonDetails } from './PersonDetails'

const nodeTypeComponents = {
  person: PersonDetails
}

export const DetailsModal = () => {
  const { state: { detailsItem, data, config }, dispatch } = useEntityGraphContext()

  const onChange = useCallback(({ nodes, edges }) => {
    if (nodes?.length === 1 && !!detailsItem) {
      return dispatch({
        type: 'TOGGLE_EDIT_SIDEBAR',
        payload: {
          path: 'detailsItem',
          value: {
            id: nodes[0].id,
            type: 'node'
          }
        }
      })
    }
    dispatch({ type: 'TOGGLE_EDIT_SIDEBAR', payload: { path: 'detailsItem', value: null } })
  }, [dispatch, detailsItem])

  useOnSelectionChange({
    onChange
  })

  const onClose = useCallback(() => {
    dispatch({ type: 'TOGGLE_EDIT_SIDEBAR', payload: { path: 'detailsItem', value: null } })
  }, [dispatch])

  const selectedItem = useMemo(() => {
    if (detailsItem?.type === 'node') {
      return data?.nodes?.find(node => node.id === detailsItem?.id)
    }
    return null
  }, [data, detailsItem])

  const canViewDetails = useMemo(() =>
    !!config.canvasSettings.canSeeDetails, [config.canvasSettings.canSeeDetails]
  )

  const NodeTypeDetailsComponent = useMemo(() => {
    if (!selectedItem || !selectedItem.data?.entityProps?.type) return null
    return nodeTypeComponents[selectedItem.data.entityProps.type] || null
  }, [selectedItem])

  if (!NodeTypeDetailsComponent || !canViewDetails) return null

  return (
    <NodeTypeDetailsComponent
      open={!!selectedItem}
      onClose={onClose}
      entityProps={selectedItem.data.entityProps}
      nodeData={selectedItem.data}
    />
  )
}
